// src/utils/analytics.js
// Thin wrapper around GA4 gtag — safe to call even if GA is not loaded.

const GA_ID = 'G-6Y3WDZFWNZ'; 

function gtag(...args) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag(...args);
  }
}

/** Call once when the user grants location and the first search runs. */
export function trackSearch({ product, radius, brand, resultsCount }) {
  gtag('event', 'search', {
    search_term: product,
    radius_km: radius,
    brand: brand || 'all',
    results_count: resultsCount,
  });
}

/** Call when the user clicks on a station card. */
export function trackStationClick({ stationName, product, price, distanceKm }) {
  gtag('event', 'select_item', {
    item_list_name: 'nearby_stations',
    items: [{
      item_name: stationName,
      item_category: product,
      price,
      item_variant: String(distanceKm) + 'km',
    }],
  });
}
